exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kKtrSR4S8xUdODnGD5os4 {\n  padding: 2rem;\n}\n._1VLcpm_1UbWu2FKNyu_pHk {\n  margin-top: 2rem;\n}\n", ""]);

// exports
exports.locals = {
	"result": "kKtrSR4S8xUdODnGD5os4",
	"buttons": "_1VLcpm_1UbWu2FKNyu_pHk"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/result.styl
 ** module id = 279
 ** module chunks = 0
 **/